import script from "./demoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./demoForm.vue?vue&type=script&setup=true&lang=js"

import "./demoForm.vue?vue&type=style&index=0&id=035df988&lang=scss&scoped=true"
import "./demoForm.vue?vue&type=style&index=1&id=035df988&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035df988"]])

export default __exports__